<template>
  <div class="lab-evaluation-container">

    <!-- Loader -->
    <div v-if="fetchData" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
    </div>

    <!-- Lab Table Section -->
    <div v-if="labContinuousLabs.length && !fetchData" class="mt-3">
      <b-card class="mt-4">

        <!-- TOP ACTION ROW -->
        <div class="d-flex justify-content-between align-items-center mb-3">

          <!-- LEFT : ADD -->
          <b-button variant="info" size="sm" @click="$bvModal.show('continuousParamModal')">
            Add / Remove Continuous Evaluation Parameters
          </b-button>

          <!-- RIGHT : SAVE -->
          <b-button variant="success" size="sm"
            @click="updateLabEvaluationOptions(activeLabId)">
            Save
          </b-button>

        </div>

        <!-- PARAMETERS TABLE -->
        <table v-if="enabledLabHeaders.length" class="table table-bordered table-striped mt-2">
          <thead>
            <tr>
              <th>No.</th>
              <th>Header</th>
              <th>Max. Score</th>
            </tr>
          </thead>
          <tbody>
            <!-- First 2 enabled headers -->
            <tr v-for="header in visibleHeaders" :key="header.name">
              <td><b-form-input v-model.number="header.no" placeholder="SI. No" type="number" min="1" /></td>
              <td>{{ header.name }}</td>
              <td><b-form-input v-model.number="header.score" placeholder="Max. score" type="number" min="0" /></td>
            </tr>

            <!-- Remaining headers shown only if expanded -->
            <template v-if="showAllHeaders">
              <tr v-for="header in remainingHeaders" :key="header.name">
                <td><b-form-input v-model.number="header.no" placeholder="SI. No" type="number" min="1" /></td>
                <td>{{ header.name }}</td>
                <td><b-form-input v-model.number="header.score" placeholder="Max. score" type="number" min="0" /></td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- SHOW MORE / LESS LINK -->
        <div v-if="enabledLabHeaders.length > 2" class="text-center mt-2">
          <b-link @click="showAllHeaders = !showAllHeaders">
            {{ showAllHeaders ? 'Show less' : 'Show more' }}
          </b-link>
        </div>

        <!-- EMPTY STATE -->
        <div v-if="!enabledLabHeaders.length" class="text-center text-muted py-4">
          No parameters added yet
        </div>
      </b-card>
    </div>

    <!-- Modal for Selecting Parameters -->
    <b-modal id="continuousParamModal" size="xl" title="Add / Remove Continuous Evaluation Parameters" centered hide-footer>

      <b-form-checkbox-group v-model="selectedParams">
        <b-row>
          <b-col cols="6" md="4" lg="3" v-for="param in labParamList" :key="param.key" class="mb-2">
            <b-form-checkbox :value="param.key">
              {{ param.name }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>

      <div class="text-right mt-3">
        <b-button variant="success" @click="saveParameters">Proceed</b-button>
        <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('continuousParamModal')">Cancel</b-button>
      </div>


    </b-modal>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LabContinuousEvaluationParameter",
  props: ["course_id"],

  data() {
    return {
      courseLabs: [],
      activeLabId: null,
      showAllHeaders: false,
      fetchData: false,
      selectedParams: [],

      labEvaluationOptions: {
        lab: {
          Practical: { id: "", enable: false, score: "", no: "", name: "Practical" },
          Record: { id: "", enable: false, score: "", no: "", name: "Record" },
          Algorithm: { id: "", enable: false, score: "", no: "", name: "Algorithm" },
          Program: { id: "", enable: false, score: "", no: "", name: "Program" },
          Output: { id: "", enable: false, score: "", no: "", name: "Output" },
          Viva: { id: "", enable: false, score: "", no: "", name: "Viva" },
          CourseProject: { id: "", enable: false, score: "", no: "", name: "CourseProject" },
          PreliminaryWork: { id: "", enable: false, score: "", no: "", name: "PreliminaryWork" },
          ImplementingTheWork: { id: "", enable: false, score: "", no: "", name: "ImplementingTheWork" },
          Performance: { id: "", enable: false, score: "", no: "", name: "Performance" },
          WrittenExam: { id: "", enable: false, score: "", no: "", name: "WrittenExam" },
          Knowledge: { id: "", enable: false, score: "", no: "", name: "Knowledge" },
          Experiment: { id: "", enable: false, score: "", no: "", name: "Experiment" },
          Documentation: { id: "", enable: false, score: "", no: "", name: "Documentation" },
          SafetyAndCleanup: { id: "", enable: false, score: "", no: "", name: "SafetyAndCleanup" },
          ToolsAndEquipment: { id: "", enable: false, score: "", no: "", name: "ToolsAndEquipment" },
          Procedure: { id: "", enable: false, score: "", no: "", name: "Procedure" },
          DataAndResult: { id: "", enable: false, score: "", no: "", name: "DataAndResult" },
          LabRecordAndGithub: { id: "", enable: false, score: "", no: "", name: "LabRecordAndGithub" },
          TimelyCompletionOfTask: { id: "", enable: false, score: "", no: "", name: "TimelyCompletion Of Task" },
          ClassViva: { id: "", enable: false, score: "", no: "", name: "ClassViva" },
          Exam: { id: "", enable: false, score: "", no: "", name: "Exam" },
          PresentationAndPreLabWork: { id: "", enable: false, score: "", no: "", name: "PresentationAndPreLabWork" },
          ConductOfExperiment: { id: "", enable: false, score: "", no: "", name: "ConductOfExperiment" },
          LabReportAndRecordKeeping: { id: "", enable: false, score: "", no: "", name: "LabReportAndRecordKeeping" },
          PreparationAndPreLabWork: { id: "", enable: false, score: "", no: "", name: "PreparationAndPreLabWork" },
        },

      },
    };
  },

  computed: {
    labContinuousLabs() {
      return this.courseLabs.filter(lab => lab.type === "lab");
    },
    enabledLabHeaders() {
      return Object.values(this.labEvaluationOptions.lab).filter(h => h.enable);
    },
    visibleHeaders() {
      return this.enabledLabHeaders.slice(0, 2);
    },
    remainingHeaders() {
      return this.enabledLabHeaders.slice(2);
    },
    labParamList() {
      return Object.entries(this.labEvaluationOptions.lab).map(([key, val]) => ({
        key,
        ...val,
      }));
    },
  },

  async created() {
    try {
      this.fetchData = true;

      // Load labs
      await this.getCourseLabs();

      // Create lab if not exists
      if (!this.labContinuousLabs.length) {
        await this.createLabForCourse();
        await this.getCourseLabs();
      }

      // Get continuous evaluation lab
      const labContinousEvaluation =
        this.labContinuousLabs.find(lab => lab.type === 'lab');

      // Proceed only if lab exists
      if (labContinousEvaluation) {
        this.activeLabId = labContinousEvaluation.id;
        await this.getLabEvaluationOptions();
      }

    } catch (error) {
      console.error("Error in created hook:", error);
    } finally {
      this.fetchData = false;
    }
  },

  methods: {
    async getCourseLabs() {
      const res = await axios.get(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities?course=${this.course_id}`
      );
      this.courseLabs = res.data;
    },

    async createLabForCourse() {
      await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities`,
        { course_id: this.course_id, type: "lab" }
      );
    },

    async getLabEvaluationOptions() {
      const res = await axios.get(
        `${this.$store.getters.getAPIKey.mainAPI}/labevaluationheaders?course=${this.course_id}`
      );
      // reset
      Object.values(this.labEvaluationOptions.lab).forEach(h => (h.enable = false));
      this.selectedParams = [];

      res.data.forEach(header => {
        if (header.lab_activity_id !== this.activeLabId) return;
        const option = this.labEvaluationOptions.lab[header.name];
        if (!option) return;

        option.id = header.id;
        option.score = header.maximum_mark;
        option.no = header.no;
        option.enable = true;

        this.selectedParams.push(header.name);
      });
    },

    saveParameters() {
      Object.entries(this.labEvaluationOptions.lab).forEach(([key, val]) => {
        val.enable = this.selectedParams.includes(key);
      });
      this.showAllHeaders = false; // reset expanded view
      this.$nextTick(() => this.$bvModal.hide("continuousParamModal"));
    },

    async updateLabEvaluationOptions(labId) {
      const payload = [];

      for (const h of this.enabledLabHeaders) {
        if (!h.score || !h.no) {
          this.$toast.error("Please fill SI.No and Max Score for all enabled parameters");
          return;
        }
        payload.push({
          name: h.name,
          maximum_mark: Number(h.score),
          no: h.no,
          lab_activity_id: labId,
        });
      }

      await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labevaluationheaders`,
        { labHeaders: payload, lab_activity_id: labId }
      );

      this.$toast.success("Parameters updated successfully");
    },
  },
};
</script>
